<template>

</template>

<script>
  import axios from 'axios';
  import config from "../../config";
  import AuthenticationManager from "../../helpers/AuthenticationManager";
  import UserApi from "../../api/User";

  export default {
    name: "Callback",
    data() {
      return {
        'handshakeId': null,
        'externalUser': {},
        'user': {},
      };
    },
    mounted() {
      const self = this;
      self.setHandshakeId();
      self.getExternalUser().then((response) => {
        self.externalUser = response.data.externalUser;
        const token = AuthenticationManager.setAccessTokenExpiryTime(response.data.token);
        AuthenticationManager.setToken(token);
        self.getUser().then(function (response) {
          self.user = response.data.scope;
          self.$store.commit('setUser', response.data);
          self.routeUser();
        });
      });
    },
    methods:
      {
        setHandshakeId() {
          const self = this;
          self.handshakeId = window.localStorage.getItem('handshake');
          window.localStorage.removeItem('handshake');
        },
        getExternalUser() {
          const self = this;
          const data = {
            'handshake_id': self.handshakeId
          };
          return axios.post(config.apiUrl + 'auth/external/user', data);
        },
        getUser() {
          return UserApi.getUser();
        },
        routeUser() {
          const self = this;
          if (self.externalUser.completed_registration === 2) {
            self.$router.push({name: 'Dashboard'});
          } else if (self.externalUser.completed_registration === 1) {
            self.$router.push({name: 'Subscription'});
          } else {
            self.$store.state.flashMessage = {
              title : "Account created!",
              body: "Please enter a few more details to get started with the Low Carb Program",
              type: "success"
            }
            self.$router.push({name: 'Register'});
          }
        },
      }
  }
</script>



// WEBPACK FOOTER //
// Callback.vue?6a6a9930